// ScrollToTop.js
import { useLayoutEffect } from "react"; // <- useLayoutEffect instead of useEffect
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    // Immediately move to top before painting the new route
    window.scrollTo(0, 0);

    // Optional: for scrollable container
    const container = document.getElementById("scroll-container");
    if (container) {
      container.scrollTop = 0;
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;
